import { AdministrationItemType } from "./data-structures";

export class ItemTypeUtil {
  static getIconClassByType(type: AdministrationItemType): string {
    switch(type) {
      case AdministrationItemType.Zone: return 'icon-location';
      case AdministrationItemType.ZoneDevice: return 'icon-chip';
      case AdministrationItemType.Tariff: return 'icon-currency';
      case AdministrationItemType.Subscription: return 'icon-ticket';
      case AdministrationItemType.ConfigBasedStructuralElementCollection: return 'icon-folder';
      case AdministrationItemType.ConfigBasedStructuralElement: return 'icon-folder';
      default: return null;
    }
  }
}
